import React from "react";

const SimpleChartBuilder = ({
  currentStep = 1,
  data = [
    { category: "Brown", value: 12, color: "#8B4513" },
    { category: "Blue", value: 8, color: "#6FA4FF" },
    { category: "Green", value: 5, color: "#4CAF50" },
    { category: "Hazel", value: 3, color: "#CD853F" },
  ],
  title = "Eye Colors in Our Class",
}) => {
  // Log props for debugging
  console.log("SimpleChartBuilder Props:", { currentStep, data, title });

  return (
    <div className="w-full bg-white p-4 rounded-xl shadow-sm">
      <div className="text-center mb-4">
        <h3 className="text-lg font-medium text-[#0D065B]">{title}</h3>
        <p className="text-sm text-[#5F29FF]">Current Step: {currentStep}</p>
      </div>

      <div className="flex justify-center space-x-4">
        {data.map((item, index) => (
          <div key={index} className="flex flex-col items-center">
            <div
              style={{
                height: `${item.value * 10}px`,
                width: "30px",
                backgroundColor: item.color,
              }}
              className="mb-2"
            />
            <span className="text-xs">{item.category}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimpleChartBuilder;
